import { render, staticRenderFns } from "./sumGender.vue?vue&type=template&id=f7825cd8"
import script from "./sumGender.vue?vue&type=script&lang=js"
export * from "./sumGender.vue?vue&type=script&lang=js"
import style0 from "./sumGender.vue?vue&type=style&index=0&id=f7825cd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports